<template>
  <div id="index">
	<ul class="select-product">
		<li v-for="(item,key) in productList" :key="key" @click="selected(key)" :class="isred == key ? 'product-item border-red' : 'product-item'">
			<img :src="item.image" alt="">
			<p>{{item.store_name}}</p>
		</li>
	</ul>
	<ul>
		<li v-for="(item,key) in productList" :key="key" v-if="isred == key" class="product">
			<div class="product-img">
				<img :src="item.image" alt="">
			</div>
			<div class="product-name">
				<p>{{item.store_name}}</p>
				<p class="product-price">￥ {{item.price}}</p>
			</div>
			<div class="product-info">
				<p class="product-info-title">商品详情</p>
				<div v-html="item.description" class="product-info-img"></div>
			</div>
			<div class="recruit-buy-footer">
				<div class="recruit-buy-button" @click="goCat(1,item.id)">立即购买</div>
				<div class="total">合计：<span class="product-price">￥ {{item.price}}</span></div>
			</div>
		</li>
	</ul>
	
	
	<Product-window v-on:changeFun="changeFun" :attr="attr" :productid="productid"></Product-window>
  </div>
</template>

<script>
import { getRecruitBuy } from "@api/user";
import {
  getProductDetail,
  postCartAdd,
  getCartCount,
  getProductCode,
  storeListApi
} from "@api/store";
import {
  getCoupon,
  getCouponReceive,
  getCollectAdd,
  getCollectDel,
  getUserInfo
} from "@api/user";
import ProductWindow from "@components/ProductWindow";
export default {
  name: "RecruitBuy",
  components: {
    ProductWindow
  },
  data: function() {
    return {
	  productList:[],
	  isred:0,
	  //立即购买
	  productid:0,
	  shareInfoStatus: false,
	  weixinStatus: false,
	  mapShow: false,
	  mapKey: "",
	  posterData: {
	    image: "",
	    title: "",
	    price: "",
	    code: ""
	  },
	  posterImageStatus: false,
	  animated: false,
	  coupon: {
	    coupon: false,
	    list: []
	  },
	  attr: {
	    cartAttr: false,
	    productAttr: [],
	    productSelect: {},
	  		RuleData:{}
	  },
	  RuleDatares:[],
	  isOpen: false, //是否打开属性组件
	  productValue: [],
	  id: 0,
	  storeInfo: {},
	  couponList: [],
	  attrTxt: "请选择",
	  attrValue: "",
	  cart_num: 1, //购买数量
	  replyCount: "",
	  replyChance: "",
	  reply: [],
	  priceName: 0,
	  CartCount: 0,
	  posters: false,
	  swiperRecommend: {
	    pagination: {
	      el: ".swiper-pagination",
	      clickable: true
	    },
	    autoplay: false,
	    loop: false,
	    speed: 1000,
	    observer: true,
	    observeParents: true
	  },
	  goodList: [],
	  system_store: {},
	  storeSelfMention: true,
	  storeItems: {},
	  activity: [],
	  navList: [],
	  lock: false,
	  navActive: 0,
	  opacity: 0
    };
  },
  mounted: function() {
    this.recruitBuy();
  },
  methods: {
	recruitBuy: function(){
		let that = this;
		getRecruitBuy().then(res => {
			that.productList = res.data;
		}).catch(err => {
			that.$dialog.error(err);
		});
	},
    selected: function(key){
		console.log(key)
		let that = this;
		that.isred = key;
	},
	//购物车；
	ChangeCartNum: function(changeValue) {
	  //changeValue:是否 加|减
	  //获取当前变动属性
	  let productSelect = this.productValue[this.attrValue];
	  //如果没有属性,赋值给商品默认库存
	  if (productSelect === undefined && !this.attr.productAttr.length)
	    productSelect = this.attr.productSelect;
	  //无属性值即库存为0；不存在加减；
	  if (productSelect === undefined) return;
	  let stock = productSelect.stock || 0;
	  let num = this.attr.productSelect;
	  if (changeValue) {
	    num.cart_num++;
	    if (num.cart_num > stock) {
	      this.$set(this.attr.productSelect, "cart_num", stock);
	      this.$set(this, "cart_num", stock);
	    }
	  } else {
	    num.cart_num--;
	    if (num.cart_num < 1) {
	      this.$set(this.attr.productSelect, "cart_num", 1);
	      this.$set(this, "cart_num", 1);
	    }
	  }
	},
	//将父级向子集多次传送的函数合二为一；
	changeFun: function(opt) {
	  console.log(opt);
	  var that = this;
	  if(opt.action == "ChangeSubject"){
			that.RuleDatares = opt.value;
	  }
			if(opt.action == "define"){
				that.goCat(1,opt.value);
			}
	  if (typeof opt !== "object") opt = {};
	  let action = opt.action || "";
	  let value = opt.value === undefined ? "" : opt.value;
	  this[action] && this[action](value);
	},
	//打开属性插件；
	selecAttrTap: function() {
	  this.attr.cartAttr = true;
	  this.isOpen = true;
	},
	changeattr: function(msg) {
	  this.attr.cartAttr = msg;
	  this.isOpen = false;
	},
	//选择属性；
	ChangeAttr: function(res) {
	  let productSelect = this.productValue[res];
	  if (productSelect) {
	    this.$set(this.attr.productSelect, "image", productSelect.image);
	    this.$set(this.attr.productSelect, "price", productSelect.price);
	    this.$set(this.attr.productSelect, "stock", productSelect.stock);
	    this.$set(this.attr.productSelect, "unique", productSelect.unique);
	    this.$set(this.attr.productSelect, "cart_num", 1);
	    this.$set(this, "attrValue", res);
	    this.$set(this, "attrTxt", "已选择");
	  } else {
	    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
	    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
	    this.$set(this.attr.productSelect, "stock", 0);
	    this.$set(this.attr.productSelect, "unique", "");
	    this.$set(this.attr.productSelect, "cart_num", 0);
	    this.$set(this, "attrValue", "");
	    this.$set(this, "attrTxt", "请选择");
	  }
	},
	//默认选中属性；
	DefaultSelect: function() {
	  let productAttr = this.attr.productAttr,
	    value = [];
	  for (var key in this.productValue) {
	    if (this.productValue[key].stock > 0) {
	      value = this.attr.productAttr.length ? key.split(",") : [];
	      break;
	    }
	  }
	  for (let i = 0; i < productAttr.length; i++) {
	    this.$set(productAttr[i], "index", value[i]);
	  }
	  //sort();排序函数:数字-英文-汉字；
	  let productSelect = this.productValue[value.join(",")];
	  if (productSelect && productAttr.length) {
	    this.$set(
	      this.attr.productSelect,
	      "store_name",
	      this.storeInfo.store_name
	    );
	    this.$set(this.attr.productSelect, "image", productSelect.image);
	    this.$set(this.attr.productSelect, "price", productSelect.price);
	    this.$set(this.attr.productSelect, "stock", productSelect.stock);
	    this.$set(this.attr.productSelect, "unique", productSelect.unique);
	    this.$set(this.attr.productSelect, "cart_num", 1);
	    // this.$set(this, "attrValue", value.sort().join(","));
	    this.$set(this, "attrValue", value.join(","));
	    this.$set(this, "attrTxt", "已选择");
	  } else if (!productSelect && productAttr.length) {
	    this.$set(
	      this.attr.productSelect,
	      "store_name",
	      this.storeInfo.store_name
	    );
	    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
	    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
	    this.$set(this.attr.productSelect, "stock", 0);
	    this.$set(this.attr.productSelect, "unique", "");
	    this.$set(this.attr.productSelect, "cart_num", 0);
	    this.$set(this, "attrValue", "");
	    this.$set(this, "attrTxt", "请选择");
	  } else if (!productSelect && !productAttr.length) {
	    this.$set(
	      this.attr.productSelect,
	      "store_name",
	      this.storeInfo.store_name
	    );
	    this.$set(this.attr.productSelect, "image", this.storeInfo.image);
	    this.$set(this.attr.productSelect, "price", this.storeInfo.price);
	    this.$set(this.attr.productSelect, "stock", this.storeInfo.stock);
	    this.$set(
	      this.attr.productSelect,
	      "unique",
	      this.storeInfo.unique || ""
	    );
	    this.$set(this.attr.productSelect, "cart_num", 1);
	    this.$set(this, "attrValue", "");
	    this.$set(this, "attrTxt", "请选择");
	  }
	},
	// 加入购物车；
	goCat: function(news,id) {
		document.getElementById("index").classList.add("noscoll");
		this.productCon(id);
	  let that = this,
	    productSelect = that.productValue[this.attrValue];
		console.log(that.RuleDatares);
			that.$set(that, "productid", id);
	  //打开属性
	  if (that.attrValue) {
	    //默认选中了属性，但是没有打开过属性弹窗还是自动打开让用户查看默认选中的属性
	    // that.attr.cartAttr = !that.isOpen ? true : false;
		that.attr.cartAttr = true;
	  } else {
	    if (that.isOpen) that.attr.cartAttr = true;
	    else that.attr.cartAttr = !that.attr.cartAttr;
	  }
	  //只有关闭属性弹窗时进行加入购物车
	  if (that.attr.cartAttr === true && that.isOpen === false)
	    return (that.isOpen = true);
	  if (
	    !this.attr.productSelect.cart_num ||
	    parseInt(this.attr.productSelect.cart_num) <= 0
	  )
	    return that.$dialog.toast({ mes: "请输入购买数量" });
			
			let q = {
			  productId: id,
			  cartNum: that.attr.productSelect.cart_num,
			  spec_type:that.attr.RuleData.spec_type,
			  spec_values:that.attr.RuleData.spec_type == 1 ? that.RuleDatares.join(',') : "",
			  new: news,
			  uniqueId:
				that.attr.productSelect !== undefined
				  ? that.attr.productSelect.unique
				  : ""
			};
	  if(that.attr.RuleData.spec_type == 1){
		  var checkedarr = that.attr.RuleData.attr_values[that.attr.productAttr[0].index];
		  var check_num = [];
		  for(var i = 0; i < checkedarr.length; i++){
			  if(checkedarr[i].check){
				  check_num.push(checkedarr[i].check);
			  }
		  }
		  console.log(check_num.length);
		  var sepc_num = that.attr.RuleData.attr_value[that.attr.productAttr[0].index].sepc_num;
		  if(check_num.length < sepc_num || q.spec_values == ""){
			  that.$layer.msg("选择科目不能小于"+sepc_num+"科");
		  }else{
			  postCartAdd(q).then(function(res) {
				  console.log(res);
				  that.isOpen = false;
				  that.attr.cartAttr = false;
					  document.getElementById("index").classList.remove("noscoll");
				  if (news) {
					that.$router.push({ path: "/order/submit/" + res.data.cartId });
				  } else {
						  that.$dialog.toast({
							mes: "添加购物车成功",
							callback: () => {
							  that.getCartCount(true);
							}
						  });
				  }
			   }).catch(res => {
				  that.isOpen = false;
				  return that.$dialog.toast({ mes: res.msg });
			   });
		  }
	  }else{
		  postCartAdd(q).then(function(res) {
			  console.log(res);
			  that.isOpen = false;
			  that.attr.cartAttr = false;
			  document.getElementById("index").classList.remove("noscoll");
			  if (news) {
				that.$router.push({ path: "/order/submit/" + res.data.cartId });
			  } else {
				  that.$dialog.toast({
					mes: "添加购物车成功",
					callback: () => {
					  that.getCartCount(true);
					}
				  });
			  }
		   }).catch(res => {
		  		that.isOpen = false;
		  		return that.$dialog.toast({ mes: res.msg });
		   });
	  }
	},
	// getImageBase64: function() {
	//   let that = this;
	//   imageBase64(this.posterData.image, that.posterData.code)
	//     .then(res => {
	//       that.posterData.image = res.data.image;
	//       that.posterData.code = res.data.code;
	//       that.isLogin && that.shareCode();
	//     })
	//     .catch(() => {
	//       that.isLogin && that.shareCode();
	//     });
	// },
	//产品详情接口；
	productCon: function(id) {
	  let that = this;
	  getProductDetail(id).then(res => {
				console.log("成功")
	      that.$set(that, "storeInfo", res.data.storeInfo);
	        that.$set(that.attr, "productAttr", res.data.productAttr);
	        that.$set(that.attr, "RuleData", res.data.RuleData);
	        that.$set(that, "productValue", res.data.productValue);
	        that.$set(that, "replyCount", res.data.replyCount);
	        that.$set(that, "replyChance", res.data.replyChance);
	        that.reply = res.data.reply ? [res.data.reply] : [];
	        that.$set(that, "reply", that.reply);
	        that.$set(that, "priceName", res.data.priceName);
	        that.posterData.image = that.storeInfo.image_base;
	        that.activity = res.data.activity ? res.data.activity : [];
	        if (that.storeInfo.store_name.length > 30) {
	          that.posterData.title =
	            that.storeInfo.store_name.substring(0, 30) + "...";
	        } else {
	          that.posterData.title = that.storeInfo.store_name;
	        }
	        that.storeSelfMention = res.data.store_self_mention ? true : false;
	        that.posterData.price = that.storeInfo.price;
	        that.posterData.code = that.storeInfo.code_base;
	        that.system_store = res.data.system_store;
	        let good_list = res.data.good_list || [];
	        let goodArray = [];
	        let count = Math.ceil(good_list.length / 6);
	        for (let i = 0; i < count; i++) {
	          var list = good_list.slice(i * 6, i * 6 + 6);
	          if (list.length) goodArray.push({ list: list });
	        }
	        that.mapKey = res.data.mapKey;
	        that.$set(that, "goodList", goodArray);
	        let navList = ["商品", "评价", "详情"];
	        if (goodArray.length) {
	          navList.splice(2, 0, "推荐");
	        }
	        that.navList = navList;
	        that.DefaultSelect();
	        that.getCartCount();
	        // that.getImageBase64();
	        if(that.attr.RuleData.spec_type == 1){
	      	  // that.getsubject();
	        }
	      }).catch(res => {
					console.log("失败111111")
	        that.$dialog.error(res.msg);
	      });
	},
	//获取被选中科目
	getsubject: function(){
		let that = this;
		let RuleData = that.attr.RuleData.attr_values[that.attr.productAttr[0].index];
			console.log("获取被选中科目");
			console.log(RuleData)
		let value = [];
		for(let i=0;i<RuleData.length;i++){
			if(RuleData[i].check){
				value.push(RuleData[i].attr);
			}
		}
		that.RuleDatares = value;
	},
	//获取购物车数量
	getCartCount: function(isAnima) {
	  let that = this;
	  const isLogin = that.isLogin;
	  if (isLogin) {
	    getCartCount({ numType: 0 }).then(res => {
	      that.CartCount = res.data.count;
	      //加入购物车后重置属性
	      if (isAnima) {
	        that.animated = true;
	        setTimeout(function() {
	          that.animated = false;
	        }, 500);
	      }
	    }).catch(err => {
				  that.$dialog.error(err);
			  });
	  }
	}
  }
};
</script>
<style scoped>
.noscoll{
	height: 100%;
	overflow: hidden;
}
.select-product{
	padding: 0.28rem 0;
	overflow: hidden;
}
.product-item{
	width: 2.2rem;
	background-color: #fff;
	padding: 0.2rem 0.1rem;
	float: left;
	margin-left: 0.25rem;
}
.product-item img{
	width: 100%;
}
.product-item p{
	font-size: 0.28rem;
}
.border-red{
	border: 1px solid #f54842;
}
.product-img{
	padding: 1rem;
	background-color: #fff;
	border-bottom: 1px solid #eee;
}
.product-img img{
	display: block;
	width: 100%;
}
.product-name{
	background-color: #fff;
	padding: 0.2rem 0.4rem;
}
.product-name p{
	font-size: 0.3rem;
}
.product-price{
	color: #db3131;
	font-size: 0.35rem;
}
.product-name .product-price{
	color: #db3131;
	font-size: 0.35rem;
}
.product-info{
	margin-top: 0.2rem;
	background-color: #fff;
	margin-bottom: 1.4rem;
}
.product-info-title{
	height: 1.26rem;
	line-height: 1.26rem;
	text-align: center;
	font-size: 0.3rem;
	font-weight: bold;
	border-bottom: 1px solid #eee;
}
.product-info-img{
	padding-top: 0.2rem;
}
.product-info-img img{
	display: block;
	width: 100%;
}
.recruit-buy-footer{
	position: fixed;
	left: 0;
	bottom: 0;
	background-color: #fff;
	overflow: hidden;
	width: 100%;
	height: 1.2rem;
	border-top: 1px solid #eee;
}
.recruit-buy-footer div{
	float: right;
	margin-right: 0.2rem;
}
.recruit-buy-button{
	background-color: #db3131;
	color: #fff;
	width: 2.5rem;
	height: 0.8rem;
	line-height: 0.8rem;
	text-align: center;
	border-radius: 30px;
	font-size: 0.3rem;
	margin-top: 0.2rem;
}
.total{
	height: 1.2rem;
	line-height: 1.2rem;
	font-size: 0.3rem;
}
</style>
